import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { selectEditTimeOffRows, selectTimeOffHoursError } from 'store/redux-store/placement-mods/selectors';
import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { validDecimal } from 'app/helpers/numberHelper';
import { Controller, useFormContext } from 'react-hook-form';


interface GridCellProps {
  [key: string]: any;
}

export const TimeOffHoursCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <TimeOffHours cellParams={cellParams} />
    </>
  );
};

export const getExistingRow = (timeOffEditRequests, cellParams) => {
  return timeOffEditRequests?.find(row => row.placementTimeOffId === cellParams?.cellParams?.row?.placementTimeOffId);
};

export const getNewRow = (timeOffEditRequests, RowId) => {
  return timeOffEditRequests?.find(row => row.id === RowId);
};

export const findRow = (cellParams, timeOffEditRequests, RowId) => {
  return cellParams?.cellParams?.row?.placementTimeOffId
    ? getExistingRow(timeOffEditRequests, cellParams)
    : getNewRow(timeOffEditRequests, RowId);
};

export const findIndex = (updatedEndDate, cellParams, timeOffEditRequests, RowId) => {
  return timeOffEditRequests?.findIndex(
    cellParams?.cellParams?.row?.placementTimeOffId
      ? row => row.placementTimeOffId === updatedEndDate.placementTimeOffId
      : row => row.id === RowId,
  );
};

const TimeOffHours = React.memo(function TimeOffHours(cellParams: GridCellProps) {
  const dispatch = useDispatch();
  const hours = cellParams?.cellParams?.row?.hours;
  const [timeOffHours, setTimeOffHours] = useState(hours === '--' ? null : hours);
  const { control } = useFormContext();
  const timeOffHoursErrors = useSelector(selectTimeOffHoursError);

  const timeOffEditRequests = useSelector(selectEditTimeOffRows);
  const RowId = cellParams?.cellParams?.id;

  const setHoursForTimeOffEdit = data => {
    let newRow = timeOffEditRequests.slice(0);
    let timeOffEditRow = findRow(cellParams, timeOffEditRequests, RowId);

    let updatedEndDate = {};

    updatedEndDate = {
      ...timeOffEditRow,
      hours: data ? parseFloat(data) : '',
    };

    let editDateIndex = findIndex(updatedEndDate, cellParams, timeOffEditRequests, RowId);
    newRow[editDateIndex] = updatedEndDate;
    dispatch(placementModsAction.setEditTimeOffRows(newRow));
    dispatch(placementModsAction.setGridModAltered(true));
  };

  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = timeOffHoursErrors?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = timeOffHoursErrors?.length > 0 ? timeOffHoursErrors?.slice(0) : [];
        const valueObj = { hours: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setTimeOffHoursError(arr));
      } else {
        const arr = timeOffHoursErrors?.slice(0);
        let currentObj = arr.find(val => val.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, hours: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(val => val.id === cellParams?.cellParams?.id);

        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setTimeOffHoursError(arr));
      }
      setTimeOffHours(null);

    }
  }, [cellParams?.cellParams?.error]);

  const checkValidDecimal = (value, onChange) => {
    if (validDecimal(value, { numberLength: 6, decimalLength: 2 })) {
      setTimeOffHours(value);
      onChange(value);
    } else {
      setTimeOffHours(value.slice(0, -1));
      onChange(null);
    }
  };

  return (
    <>
      <Controller
        name={`timeOffRequests${RowId}.hours`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: '150px',
            }}
            value={timeOffHours}
            onBlur={e => {
              if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                setHoursForTimeOffEdit(e.target.value);
              }
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                checkValidDecimal(e.target.value, onChange);
              } else {
                setTimeOffHours(null);
              }
            }}

            {...rest}
          />
        )}
      />
    </>
  );
});
